import React, { ReactElement } from "react"
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import MemberCardStyles from "./memberCard.styles";
import PersonIcon from '@material-ui/icons/Person';
import SharpImage from "../utils/sharpImage";
import HtmlContent from "../utils/htmlContent";
import { useTheme } from "@material-ui/core/styles";

type ImageSizes = "sml" | "md" | "lg";

interface Props {
    memberId: string;
    children?: ReactElement;
    imageRight?: boolean;
    size?: ImageSizes;
    people: IPerson[];
    color?: string;
    nameColor?: string;
    hideImage?: boolean;
}

interface IPerson {
    itemId: string;
    name: string;
    bio: { rendered: string };
    image: any;
    tag: string;
    enabled: string;
    nameColor?: string;
}

export const MemberCard = ({ memberId, people, imageRight, size, color, nameColor, hideImage }: Props) => {
    const classes = MemberCardStyles();

    if (size !== "sml" && size !== "md" && size !== "lg")
        size = "md"; //Default to md

    const person = memberId && people && people.find(x => x.itemId === memberId);

    const theme = useTheme();

    const getBackground = () => {
        if (color === "darkest")
            return theme.palette.primary.darkest;
        else if (color === "dark")
            return theme.palette.primary.dark;
        else if (color === "main")
            return theme.palette.primary.main;
        else if (color === "light")
            return theme.palette.primary.light;
        else if (color === "lightest")
            return theme.palette.primary.lightest;
        else
            return theme.palette.background.paper
    }

    const getNameColor = () => {
        if (nameColor)
            return nameColor;
        else
            return theme.palette.getContrastText(getBackground());
    }

    return (
        <div className={`${classes.cardContainer} ${size === "sml" ? classes.cardContainerSml : ""}  ${size === "md" ? classes.cardContainerMd : ""}  ${size === "lg" ? classes.cardContainerLg : ""}`}
            style={{ backgroundColor: getBackground(), color: theme.palette.getContrastText(getBackground()) }}>
            {!imageRight && !hideImage &&
                <div className={`${classes.cardImgContainer} ${size === "lg" ? classes.cardImgContainerLg : ""}`}>
                    {person && person.image ?
                        <div className={classes.cardImg}><SharpImage file={person.image} title={person.name} altText={person.name} /></div>
                        : <PersonIcon style={{ width: "100%", height: "100%" }} />}
                </div>
            }
            <Box className={`${classes.cardSummaryContainer} ${hideImage ? classes.cardSummaryContainerNoImage : ""}`}>
                <Typography variant="h5" className={classes.title} style={{ color: getNameColor() }}>{person && person.name}</Typography>
                <div className={classes.content}>{person && <HtmlContent content={person.bio.rendered} />}</div>
            </Box>
            {imageRight && !hideImage &&
                <div className={`${classes.cardImgContainer} ${size === "lg" ? classes.cardImgContainerLg : ""}`}>
                    {person && person.image ?
                        <div className={classes.cardImg}><SharpImage file={person.image} title={person.name} altText={person.name} /></div>
                        : <PersonIcon style={{ width: "100%", height: "100%" }} />}
                </div>
            }
        </div>
    );
}

MemberCard.NAME = "MemberCard";
export default MemberCard
